/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime';
import Slick from 'vue-slick-carousel'
import VueCookies from 'vue-cookies';
import VueGtm from '@gtm-support/vue2-gtm';

// import 'vue-slick-carousel/dist/vue-slick-carousel.css'

window.Vue = require('vue').default;
import store from './store'

Vue.use(VueCookies);
Vue.component('app-header', () => import('./components/Header'));
Vue.component('app-popup-modal', () => import('./components/PopupModal'));
// Vue.component('app-slideshow-services', () => import('./components/SliderServices'));
// Vue.component('app-map', () => import('./components/Map'));
Vue.component('form-select-search', () => import('./components/SelectSearch'));
Vue.component('app-expandable', () => import('./components/Expandable'));
Vue.component('read-moreable', () => import('./components/ReadMoreable'));
Vue.component('footer-accordion', () => import('./components/FooterAccordion'));
Vue.component('breadcrumbs', () => import('./components/Breadcrumbs'));

Vue.component('form-book-online', () => import('./booking/BookOnline'));
Vue.component('form-booking', () => import('./booking/Index'));

Vue.component('location-dropdown', () => import('./components/LocationDropdown'))
Vue.component('insurance-card', () => import('./components/InsuranceCard'))
Vue.component('car-details-card', () => import('./components/CarDetailsCard'))
Vue.component('car-details-card-all', () => import('./components/CarDetailsCardAll'))
Vue.component('review-card', () => import('./components/ReviewCard'))
Vue.component('guide-card', () => import('./components/GuideCard'))

const app = new Vue({
  el: '#app',
  components: { Slick },
  store,

  data: () => ({
    isLoaded: false,
    isNavOpen: false,
    isSecondMenuOpen: false,
    isBookingHidden: false,
    isHeaderLoaded: false,
    isBookingLoaded: false,
    year: new Date().getFullYear(),
    openAccordion: 0,
    homeVideoUrl: '',
    width: document.documentElement.clientWidth,
    showAllCars: false,
    visibleCount: 2, // Initial number of visible vehicles
    increment: 10, // Number of vehicles to load each time
    vehiclesList: [], // Will be populated in mounted hook
    footerSections: [
      {
        title: 'Locations',
        contentType: 'div',
        items: [
          { text: 'Brisbane Airport', link: '/branches/car-hire-brisbane-airport' },
          { text: 'Gold Coast Airport', link: '/branches/coolangatta-airport-gold-coast' },
          { text: 'Sunshine Coast', link: '/branches/maroochydore-airport-sunshine-coast' },
        ]
      },
      {
        title: 'Our Vehicles',
        contentType: 'div',
        items: [
          { text: 'Luxury Car Hire', link: '/our-vehicles/luxury-car-hire' },
          { text: 'SUV Car Hire', link: '/our-vehicles/suv-car-hire' },
          { text: 'Large Car Hire', link: '/our-vehicles/large-car-hire' },
          { text: 'Medium Car Hire', link: '/our-vehicles/medium-car-hire' },
          { text: 'Small Car Hire', link: '/our-vehicles/small-car-hire' },
        ]
      }
    ]
  }),

  computed: {
    hasMoreVehicles() {
      const hasMore = this.vehiclesList.length > this.visibleCount;
      console.log('Vehicle stats:', {
        totalVehicles: this.vehiclesList.length,
        visibleCount: this.visibleCount,
        hasMore
      });
      return hasMore;
    }
  },

  mounted() {
    // Initialize vehicles data from data attribute
    const vehiclesContainer = document.querySelector('[data-vehicles]');
    if (vehiclesContainer) {
      try {
        const vehiclesData = JSON.parse(vehiclesContainer.dataset.vehicles);
        console.log('Loaded vehicles:', vehiclesData);
        this.vehiclesList = vehiclesData;
      } catch (e) {
        console.error('Error parsing vehicles data:', e);
        this.vehiclesList = [];
      }
    } else {
      console.warn('No vehicles container found');
    }

    if (window.location.pathname === '/booking/select-your-vehicle' ||
        window.location.pathname === '/booking/pick-insurance' ||
        window.location.pathname === '/booking/provide-details' ||
        window.location.pathname === '/booking/payment' ||
        window.location.pathname === '/booking/confirmation') {
      this.isBookingHidden = true;
    }

    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isLoaded = true;
      }
    }
  },

  methods: {
    navToggle(value) {
      this.isNavOpen = value;
    },

    toggleSecondMenu() {
      this.isSecondMenuOpen = !this.isSecondMenuOpen;
    },

    toggleAccord(number) {
      if (this.openAccordion !== number) {
        this.openAccordion = number;
      } else {
        this.openAccordion = 0;
      }
    },

    toggleVideo(url) {
      if (url) {
        this.homeVideoUrl = url;
      } else {
        this.homeVideoUrl = '';
      }
    },


    handleBookingError(error) {
      console.error('Booking form error:', error)
      // You might want to show an error message to the user
      // If you're using a store for notifications:
      if (this.$store) {
        this.$store.commit('setPopup', {
          open: true,
          content: '<h6>Error</h6><p>There was an error loading the booking form. Please try refreshing the page.</p>'
        })
      }
    },

    loadMore() {
      const newCount = Math.min(
        this.visibleCount + this.increment,
        this.vehiclesList.length
      );
      console.log('Loading more vehicles:', {
        oldCount: this.visibleCount,
        newCount,
        total: this.vehiclesList.length
      });
      this.visibleCount = newCount;
    }
  }
});

Vue.use(VueGtm, {
  id: 'GTM-MVXF99', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

function toggleLength(id) {
  console.log(id)
  document.getElementById(id).classList.toggle("show-all");
}
